// extracted by mini-css-extract-plugin
export var copyableField = "_p3-4";
export var customerBadge = "_p3-0";
export var customerInfoTitle = "_p3-2";
export var details = "_p3-1";
export var dropdownContainer = "_p3-5";
export var dropdownImage = "_p3-6";
export var editAssigneeForm = "_p3-a";
export var editButton = "_p3-3";
export var email = "_p3-7";
export var hidden = "_p3-d";
export var input = "_p3-8";
export var saveButton = "_p3-b";
export var shopifyIcon = "_p3-c";
export var suggestionBadge = "_p3-e";
export var suggestionText = "_p3-f";
export var username = "_p3-9";